import useAuthenticatedFetch from "./common/useAuthenticatedFetch";
import { ApiResponse } from "./models/ApiResponse";
import {
    DataAssuranceDashboardResponse,
    EmissionsDashboardResponse,
} from "./models/Dashboard";

export const useEmissionsDashboard = (fromDate: string, toDate: string) => {
    const { response, isLoading } = useAuthenticatedFetch<
        ApiResponse<EmissionsDashboardResponse>
    >(`api/emissions-dashboard?fromDate=${fromDate}&toDate=${toDate}`);

    return {
        emissionsDashboardData: response?.content,
        isLoading,
    };
};

export const useDataAssuranceDashboard = () => {
    const { response, isLoading } = useAuthenticatedFetch<
        ApiResponse<DataAssuranceDashboardResponse>
    >("api/data-assurance-dashboard");

    return {
        assuranceDashboardData: response?.content,
        isLoading,
    };
};
